import { Share2 } from "lucide-react";
import { proxyImg } from "@/utils/imageProxy";

const COLLECTION_IMAGES = {
  "most-popular": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/43a141pe_Most%20Popular.JPG",
  "5-servings": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/0bmu3x7e_5%20Servings.jpg",
  "7-servings": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/r5kgf5dn_7%20servings.jpg",
  "8-servings": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/o5w00ru5_8%20servings.png",
  "12-servings": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/lk5zfeaf_12%20servings.jpg",
  "basket": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/xswea2zg_BASKET.jpg",
  "anniversary": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/ss9vbihh_Anniversary.jpg",
  "birthday": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/ud6quuiq_Birthday.jpg",
  "miss-you": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/356bbmcd_Miss%20You%20.jpg",
  "love-n-romance": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/p6fr6rbo_Love%20n%20Romance.jpg",
  "congratulations": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/hk8ae1nw_Congratulations.jpg",
  "designer-cupcakes": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/aju7zloa_IMG_9198.jpg",
  "cake-cupcake-combo": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/7c96kyp1_Cake%20n%20cupcake%20combo.jpg",
  "engagement": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/dj2td3nr_Engagement%20Cakes.JPG",
  "bridal-special": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/f3bpctve_Bridal%20Special.png",
  "packaging": "https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/owmccxk6_Packaging.jpg",
};

const COLLECTIONS = [
  { id: "most-popular", name: "Most Popular", emoji: "\u{1F31F}", originalPrice: 1850, discountedPrice: 1758, showDiscount: true },
  { id: "8-servings", name: "8 Servings", emoji: "\u{1F380}", originalPrice: 1850, discountedPrice: 1758, desc: "Box Packed", showDiscount: true },
  { id: "12-servings", name: "12 Servings", emoji: "\u{1F338}", originalPrice: 2100, discountedPrice: 1995, desc: "Box Packed", showDiscount: true },
  { id: "basket", name: "Basket", emoji: "\u{1F9FA}", originalPrice: 2800, discountedPrice: 2660, desc: "18 Servings", showDiscount: true },
  { id: "anniversary", name: "Anniversary", emoji: "\u{1F495}", originalPrice: 1850, discountedPrice: 1758, showDiscount: true },
  { id: "birthday", name: "Birthday", emoji: "\u{1F389}", originalPrice: 1850, discountedPrice: 1758, showDiscount: true },
  { id: "miss-you", name: "Miss You", emoji: "\u{1F490}", originalPrice: 1850, discountedPrice: 1758, showDiscount: true },
  { id: "love-n-romance", name: "Love N Romance", emoji: "\u2764\uFE0F", originalPrice: 1850, discountedPrice: 1758, showDiscount: true },
  { id: "congratulations", name: "Congratulations", emoji: "\u{1F3C6}", originalPrice: 1850, discountedPrice: 1758, showDiscount: true },
  { id: "designer-cupcakes", name: "Designer Cupcakes", emoji: "\u{1F9C1}", originalPrice: 1800, discountedPrice: 1710, desc: "12 Pcs", showDiscount: true },
  { id: "cake-cupcake-combo", name: "Cake & Cupcake Combo", emoji: "\u{1F381}", originalPrice: 2650, discountedPrice: 2518, desc: "Cake + 5 Cupcakes", showDiscount: true },
  { id: "engagement", name: "Engagement Cakes", emoji: "\u{1F48D}", originalPrice: 3500, discountedPrice: 3325, desc: "2 Tier", showDiscount: true },
  { id: "bridal-special", name: "Bridal Special", emoji: "\u{1F470}", originalPrice: 2160, discountedPrice: 2052, desc: "Ring / Cupcakes", showDiscount: true },
  { id: "packaging", name: "Packaging", emoji: "\u{1F4E6}", originalPrice: null, discountedPrice: null, desc: "Included", showDiscount: false },
];

function formatPrice(num) {
  return num ? `\u20B9${num.toLocaleString("en-IN")}` : "";
}

function CollectionPrice({ collection }) {
  if (collection.showDiscount && collection.discountedPrice) {
    return (
      <div className="flex items-center gap-1.5">
        <span className="text-[11px] text-gray-400 line-through">
          From {formatPrice(collection.originalPrice)}
        </span>
        <span className="text-[11px] font-semibold text-red-600">
          {formatPrice(collection.discountedPrice)}
        </span>
      </div>
    );
  }
  if (collection.originalPrice) {
    return (
      <span className="text-[11px] text-gray-500">
        From {formatPrice(collection.originalPrice)}
      </span>
    );
  }
  return (
    <span className="text-[11px] text-gray-500">
      {collection.desc || "Premium"}
    </span>
  );
}

function handleWhatsAppShare(e, collection) {
  e.stopPropagation();
  const priceText = collection.discountedPrice
    ? `Now only ${formatPrice(collection.discountedPrice)} (5% OFF!)`
    : "Premium packaging included";
  const text = `Hey! Check out this beautiful ${collection.name} ${collection.emoji} cake from Sugar Bouquet India! ${priceText}. 100% eggless designer buttercream flower cakes, freshly baked same day with AC car delivery! Order now!`;
  const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export default function CollectionGrid({ onCollectionClick }) {
  return (
    <div data-testid="collection-grid">
      <div className="flex items-center gap-3 mb-4">
        <div className="h-8 w-8 rounded-full overflow-hidden bg-white border border-gray-100 flex items-center justify-center flex-shrink-0">
          <img src={proxyImg("https://customer-assets.emergentagent.com/job_cake-design-studio-5/artifacts/5xphm2ah_Sugar%20Bouquet%20Logo.png", 64, 80)} alt="Sugar Bouquet" className="w-full h-full object-contain p-0.5" />
        </div>
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-widest">
          Explore Our 14 Designer Collections
        </h3>
      </div>
      <div className="ml-11 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2.5">
        {COLLECTIONS.map((collection) => (
          <div
            key={collection.id}
            className="group relative overflow-hidden rounded-xl border border-gray-100 bg-white hover:border-gray-300 transition-all duration-300 hover:shadow-lg cursor-pointer text-left"
            onClick={() => onCollectionClick(collection)}
            data-testid={`collection-card-${collection.id}`}
          >
            <div className="aspect-[4/3] w-full overflow-hidden bg-gray-50 relative">
              <img
                src={proxyImg(COLLECTION_IMAGES[collection.id])}
                alt={collection.name}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                decoding="async"
                width={400}
                height={300}
              />
              {/* 5% OFF Badge */}
              {collection.id !== "packaging" && (
                <div
                  className="absolute top-1.5 left-1.5 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-md shadow-sm"
                  data-testid={`discount-badge-${collection.id}`}
                >
                  5% OFF
                </div>
              )}
              {/* WhatsApp Share Button */}
              <button
                onClick={(e) => handleWhatsAppShare(e, collection)}
                className="absolute top-1.5 right-1.5 h-7 w-7 rounded-full bg-white/90 backdrop-blur-sm text-gray-600 hover:bg-green-500 hover:text-white flex items-center justify-center transition-all duration-200 opacity-0 group-hover:opacity-100 shadow-sm"
                data-testid={`whatsapp-share-${collection.id}`}
                aria-label={`Share ${collection.name} on WhatsApp`}
                title="Share on WhatsApp"
              >
                <Share2 className="w-3.5 h-3.5" />
              </button>
            </div>
            <div className="px-2.5 py-2">
              <div className="flex items-center gap-1 mb-0.5">
                <span className="text-sm">{collection.emoji}</span>
                <span className="font-semibold text-xs text-gray-900 line-clamp-1 group-hover:underline decoration-1 underline-offset-2">
                  {collection.name}
                </span>
              </div>
              <CollectionPrice collection={collection} />
              {collection.desc && collection.discountedPrice && (
                <span className="text-[10px] text-gray-400 block">{collection.desc}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
